import { SignIn } from '@clerk/clerk-react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import mesaValley from '@/assets/mesa-valley.webp?url';

export const Route = createFileRoute('/sign-in/$')({
  validateSearch: zodValidator(
    z.object({
      redirectTo: z.string().default('/'),
    })
  ),
  beforeLoad: ({ context: { isSignedIn }, search: { redirectTo } }) => {
    if (isSignedIn) throw redirect({ to: redirectTo });
  },
  component: SignInPage,
});

export function SignInPage() {
  const { redirectTo } = Route.useSearch();

  const redirectUrl = `/auth/callback?redirectTo=/${redirectTo.slice(1)}`;

  return (
    <div
      className="flex h-screen w-screen justify-center items-center bg-amber-50"
      style={{
        backgroundImage: `url('${mesaValley}')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundColor: '#000',
      }}
    >
      <SignIn
        forceRedirectUrl={redirectUrl}
        withSignUp={true}
        appearance={{
          elements: {
            footerAction: {
              display: 'none',
            },
          },
        }}
      />
    </div>
  );
}
